import type { Location } from 'history'

import { BaseNavigationConfirmation } from './BaseNavigationConfirmation'
import { useFormContext } from './use-form-context'

export function HashNavigationConfirmation() {
  const form = useFormContext()

  const confirmationRequiredWhen = (currentLocation: Location, nextLocation?: Location): boolean => {
    return currentLocation.hash !== nextLocation?.hash && form.dirty
  }

  return <BaseNavigationConfirmation when={confirmationRequiredWhen} />
}
